// Calls to /api/ai (Claude-powered features). Errors carry the Czech message from the server.

import { resizeImage } from './deliveryApi';

export const AI_API = '/api/ai';

export async function aiApi(path, { method = 'GET', body, form } = {}) {
  const res = await fetch(`${AI_API}${path}`, {
    method,
    credentials: 'include',
    headers: form ? undefined : { 'Content-Type': 'application/json' },
    body: form || (body !== undefined ? JSON.stringify(body) : undefined),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) {
    const err = new Error(json.details?.[0]?.msg || json.error || `Chyba ${res.status}`);
    err.status = res.status;
    err.code = json.code;
    throw err;
  }
  return json.data;
}

// Phone photos above this size are downscaled before upload (Claude accepts images up to 5 MB).
const IMAGE_RESIZE_BYTES = 3 * 1024 * 1024;

export async function shrinkPhoto(file) {
  if (!file?.type?.startsWith('image/') || file.size <= IMAGE_RESIZE_BYTES) return file;
  try {
    const blob = await resizeImage(file, 2400, 0.85);
    if (!blob || blob.size >= file.size) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' });
  } catch {
    return file;
  }
}

// Upload one file (field "file") with optional extra form fields.
export async function aiUpload(path, file, fields = {}) {
  const form = new FormData();
  form.append('file', await shrinkPhoto(file));
  Object.entries(fields).forEach(([k, v]) => { if (v !== undefined && v !== null) form.append(k, String(v)); });
  return aiApi(path, { method: 'POST', form });
}

export const formatScore = (score) => `${Math.round((score || 0) * 100)} %`;

// Colour of a confidence badge: green = sure, amber = check it, grey = weak.
export const scoreColor = (score) => (score >= 0.9 ? '#2E7D32' : score >= 0.6 ? '#F9A825' : '#9E9E9E');

export const AI_ACCEPT = 'application/pdf,image/jpeg,image/png,image/webp,image/gif';
